"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var financeSectionStyles = styles_1.makeStyles(function (_a) {
    var _b, _c;
    var breakpoints = _a.breakpoints;
    return ({
        financeWrapper: (_b = {
                marginBottom: '40px',
                padding: '0 30px'
            },
            _b[breakpoints.down('sm')] = {
                padding: '0 15px',
            },
            _b),
        financeDetails: (_c = {
                padding: '10px 0',
                width: '100%'
            },
            _c[breakpoints.down('sm')] = {
                textAlign: 'center',
            },
            _c),
        title: {
            display: 'block',
            fontWeight: 700,
            marginBottom: '10px',
        },
        details: {
            display: 'block',
            marginBottom: '20px',
        },
        image: {},
    });
}, { name: 'Checkout_FinanceSection' });
exports.default = financeSectionStyles;
